<template>
  <div class="container">
    <h1 class="display-1">:( 404</h1>
    <h4 class="display-4">Não encontrado</h4>
  </div>
</template>

<script>
export default {
  name: 'error'
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// Error.vue?6e45dec3